
export interface AddPromotionModel{
    id:number
    brandId: number
    categoryId: number
    promotionNames: string
    categoryNames: string
    promotionDescription:string
    enpromotionNames: string
    depromotionNames: string
    nlpromotionNames: string
    encategoryNames: string
    decategoryNames: string
    nlcategoryNames: string
    createdBy: string
    imageBinaryData: string 
    mimeType: string
    image: string | ArrayBuffer
    promotionImage: string | ArrayBuffer
    languageCode: string
    originalPrice: number
    startDate: Date
    endDate: Date
    isMultipleAllowed: boolean
    quantity: number
    offerPrice: number
    offerStartDate: string
    offerEndDate: string
}
export interface PromotionModel{
    promotionDetails: Promotion,
    promotionNames: LanguageDetail[],
    categoryNames: LanguageDetail[],
    promotionDescription: LanguageDetail[]
}

export interface LanguageDetail{
    LanguageId:number,
    Description: string
}

export interface EditPromotion{
     brandId: number
     categoryId: number
     promotionDescription: string
     description: string
     updatedBy: string
     imageBinaryData: string 
     mimeType: string
     image: string | ArrayBuffer
     promotionImage: string | ArrayBuffer
     originalPrice: number
    startDate: Date
    endDate: Date
    isMultipleAllowed: boolean
    quantity: number
    offerPrice: number
    offerStartDate: string
    offerEndDate: string
}

export interface Promotions{
    id: number
    brandId: number
    categoryId: number
    dealerId: string
    promotionImage: string
    promotionName: string
    category: string
    createdBy: string
    createdDate: any
    updatedBy: string
    updatedDate: any,
    brand: string,
    dealer: string
    isActive: boolean,
    promotionDescription: string,
    originalPrice: number,
    startDate: string,
    endDate: string,
    isMultipleAllowed: boolean,
    quantity: number,
    offerPrice: number,
    offerStartDate: string,
    offerEndDate: string
}

export interface Promotion{
    id: number
    brandId: number
    categoryId: number
    dealerId: string
    promotionImage: string
    promotion: string
    category: string
    dealer: string
    createdBy: string
    createdDate: Date
    updatedBy: string
    updatedDate: Date
    brand: string
    isActive: boolean
    promotionDescription:string
    originalPrice: number
    startDate: string
    endDate: string
    isMultipleAllowed: boolean
    quantity: number
    offerPrice: number
    offerStartDate: string
    offerEndDate: string
    imagePath:string
}

export class ActiveDealerDataMapper{
    dealerId: string
    dealerName: string
    isDealerActive: boolean
    isActiveDealerForPromotion: boolean
}

export class GetAllActiveDealerResponseModel{
    dealerId: string;
    isActive: boolean;
}